import * as _ from 'lodash';
import { CREATE_CARTRULE_REQUESTED, CREATE_CARTRULE_SUCCEEDED, CREATE_CARTRULE_ERROR } from './create.actions';
import { Router } from '@angular/router';
import { put, takeEvery } from 'redux-saga/effects';
import { API_CALL_ERROR } from '../../../store/action';
import { ApiService } from '../../../api/api.service';
import { AppInjector } from '../../../app-injector';
import {NotificationService} from "../../../common/services/notification/notification.service";
import {UtilityService} from "../../../common/services/utility/utility.service";

function* createCartrule(action) {
  const api = AppInjector.get(ApiService);
  const router = AppInjector.get(Router);
  try {
    let result = yield api.cartrule.create(action.data).toPromise();
    yield put({ type: CREATE_CARTRULE_SUCCEEDED, data: result });
    if (_.isNil(action.no_redirect) || action.no_redirect) {
      AppInjector.get(UtilityService).redirectAndReset('cartrule');
    }
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchCreateCartruleRequest() {
  yield takeEvery(CREATE_CARTRULE_REQUESTED, createCartrule);
}

function* createCartruleError(action) {
  AppInjector.get(NotificationService).show('warning', (action as any).message, 5000);
}

function* watchCreateCartruleError() {
  yield takeEvery(CREATE_CARTRULE_ERROR, createCartruleError);
}

export default [watchCreateCartruleRequest, watchCreateCartruleError];
